import SkipButton from './SkipButton';

export default SkipButton;
